import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right.svg'
import _imports_1 from '@/assets/images/mobile/external-links-err-img.png'


const _withScopeId = n => (_pushScopeId("data-v-e756b6ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-mobile bg-white overflow-auto height-fill" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "mx-auto fw-bold pe-4 fs-22-custom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "success"
}, null, -1))
const _hoisted_5 = { class: "text-1 mt-4" }
const _hoisted_6 = { class: "text-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["header d-flex text-black px-3 custom-fs-18 container-390 position-fixed align-items-center justify-content-between", [$setup.getAgentType===1?'pth-android':$setup.getAgentType===2? 'pth-ios':'']])
      }, [
        _createElementVNode("img", {
          role: "button",
          src: _imports_0,
          alt: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.BackToMain()))
        }),
        _createElementVNode("div", _hoisted_3, _toDisplayString($setup.title_), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content-all-points px-3 d-flex flex-column align-items-center text-center ext-links-err-content", [$setup.getAgentType===1?'ptc-android':$setup.getAgentType===2? 'ptc-ios':'']])
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.local.external_links_error_page2), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.local.external_links_error_page3), 1),
        _createElementVNode("button", {
          class: "refresh-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.reloadPage()))
        }, _toDisplayString($setup.local.external_links_error_page4), 1)
      ], 2)
    ])
  ]))
}